module.exports = __webpack_public_path__ + "static/media/nft_icon_gr.0b89919c.svg";